import Vue from 'vue'
import halson from '@/services/HALSONResource.coffee'

Client = () ->
  halson
    uid: null
    id: null
    start: null
    end: null
    gender: null
    year: null
    note:
      ops: []

moveElement = (array, old_index, new_index) ->
  target = array[old_index]
  incr = (new_index - old_index) / Math.abs(new_index - old_index)
  el = old_index
  while el != new_index
    array[el] = array[el + incr]
    el += incr
  array[new_index] = target
  for item, idx in array
      item.sortorder = idx
  array

getProperty = (state, mutation) ->
  state.cprop_groups
  .getEmbedByRelAndUID 'client_property_groups', mutation.payload.client_property_group_id
  .getEmbedByRelAndUID 'client_property_definition', mutation.payload.uid

getOption = (state, mutation) ->
  state.cprop_groups
  .getEmbedByRelAndUID 'client_property_groups', mutation.payload.property_group_uid
  .getEmbedByRelAndUID 'client_property_definition', mutation.payload.property_uid
  .getEmbedByRelAndUID 'client_property_option', mutation.payload.uid

getOptionParent = (state, mutation) ->
  state.cprop_groups
  .getEmbedByRelAndUID 'client_property_groups', mutation.payload.property_group_uid
  .getEmbedByRelAndUID 'client_property_definition', mutation.payload.property_uid

export default
  'SHOW_DIALOG': (state, mutation) ->
    Vue.set state, 'dialog', mutation.dialog

  'SELECT_CLIENT': (state, mutation) ->
    state.selected_client = mutation.selected_client

  'NEW_CLIENT': (state, mutation) ->
    state.selected_client = new Client()

  'XHR_IS_LOADING': (state, mutation) ->
    state.xhr_is_loading = mutation.xhr_is_loading

  'WORKING': (state, mutation) ->
    state.working = mutation.working

  'SET_ACTIVITIES': (state, mutation) ->
    state.activities = mutation.payload
    state.are_loaded.activities = true

  'SET_ACTIVITY_TYPES': (state, mutation) ->
    state.activity_types = mutation.payload
    state.are_loaded.activity_types = true

  'SET_CLIENT_LIST': (state, mutation) ->
    state.client_list = mutation.payload
    state.are_loaded.client_list = true

  'SET_CLIENT_NOTE': (state, mutation) ->
    state.selected_client.note = mutation.note

  'SET_CONFIGS': (state, mutation) ->
    state.configs = mutation.payload

  'SET_CPROP_GROUPS': (state, mutation) ->
    state.cprop_groups = mutation.payload
    state.are_loaded.groups = true
    state.are_loaded.configs = true

  'SET_RESOURCES': (state, mutation) ->
    state.resources = mutation.resources
    state.are_loaded.resources = true

  'ADD_ACTIVITY': (state, mutation) ->
    state.activities.addEmbed('activities', mutation.payload)

  'ADD_ACTIVITY_TYPE': (state, mutation) ->
    state.activity_types.addEmbed('activity_type', mutation.payload)

  'ADD_CPROP': (state, mutation) ->
    state.cprop_groups
    .getEmbedByRelAndUID 'client_property_groups', mutation.payload.client_property_group_id
    .addEmbed 'client_property_definition', mutation.payload

  'ADD_CPROP_GROUP': (state, mutation) ->
    state.cprop_groups.addEmbed('client_property_groups', mutation.payload)

  'ADD_OPTION': (state, mutation) ->
    getOptionParent(state, mutation)
    .addEmbed 'client_property_option', mutation.payload

  'DELETE_ACTIVITY': (state, mutation) ->
    state.activities
    .removeEmbedByRelAndUID 'activities', mutation.payload.uid

  'DELETE_ACTIVITY_TYPE': (state, mutation) ->
    state.activity_types
    .removeEmbedByRelAndUID 'activity_type', mutation.activity_type.uid

  'DELETE_CPROP': (state, mutation) ->
    state.cprop_groups
    .getEmbedByRelAndUID 'client_property_groups', mutation.payload.client_property_group_id
    .removeEmbedByRelAndUID 'client_property_definition', mutation.payload.uid

  'DELETE_CPROP_GROUP': (state, mutation) ->
    state.cprop_groups
    .removeEmbedByRelAndUID 'client_property_groups', mutation.payload.uid

  'DELETE_OPTION': (state, mutation) ->
    getOptionParent(state, mutation)
    .removeEmbedByRelAndUID 'client_property_option', mutation.payload.uid

  'UPDATE_ACTIVITY': (state, mutation) ->
    activity = state.activities.getEmbedByRelAndUID 'activities', mutation.payload.uid
    _.assign activity, mutation.payload

  'UPDATE_ACTIVITY_TYPE': (state, mutation) ->
    type = state.activity_types.getEmbedByRelAndUID 'activity_type', mutation.payload.uid
    _.assign type, mutation.payload

  'UPDATE_ACTIVITY_TYPES': (state, mutation) ->
    state.activity_types.removeEmbeds 'activity_type'

    mutation.types.map (g)->
      state.activity_types.addEmbed 'activity_type', g

  'UPDATE_GROUPS': (state, mutation) ->
    state.cprop_groups.removeEmbeds 'client_property_groups'

    mutation.groups.map (g)->
      state.cprop_groups.addEmbed 'client_property_groups', g

  'UPDATE_CPROP_GROUP': (state, mutation) ->
    group = state.cprop_groups.getEmbedByRelAndUID 'client_property_groups', mutation.payload.uid

    _.assign group, mutation.payload

  'UPDATE_CPROP': (state, mutation) ->
    prop = getProperty state, mutation

    _.assign prop, mutation.payload

  'UPDATE_PROPS': (state, mutation) ->
    console.log mutation
    group = state.cprop_groups.getEmbedByRelAndUID 'client_property_groups', mutation.group.uid

    group.removeEmbeds 'client_property_definition'

    for p in mutation.props
      group.addEmbed 'client_property_definition', p

  'UPDATE_OPTIONS': (state, mutation) ->
    prop = getOptionParent state, mutation

    prop.removeEmbeds 'client_property_option'

    for o in mutation.options
      prop.addEmbed 'client_property_option', o


  'UPDATE_OPTION': (state, mutation) ->
    option = getOption state, mutation

    _.assign option, mutation.payload

  'UPDATE_CONFIG': (state, mutation) ->
    config = state.configs.getEmbedByRelAndUID 'config', mutation.payload.key
    _.assign config, mutation.payload


  'REORDER_CPROP_GROUP': (state, mutation) ->
    groups = state.cprop_groups
    moveElement groups, mutation.old_index, mutation.new_index

  'REORDER_PROPERTY': (state, mutation) ->
    properties =
      state.cprop_groups
      .getEmbedByRelAndUID 'client_property_groups', mutation.group_uid
      .getEmbeds('client_property_definition')
    moveElement properties, mutation.old_index, mutation.new_index

  'REORDER_OPTION': (state, mutation) ->
    options = state.cprop_groups[mutation.group_index]
                .getEmbeds('client_property_definition')[mutation.property_index]
                .getEmbeds('client_property_option')
    moveElement options, mutation.old_index, mutation.new_index

  'UPDATE_USER': (state, mutation) ->
    state.user = mutation.user
    sessionStorage.first_name = state.user.first_name
    sessionStorage.last_name = state.user.last_name
    sessionStorage.username = state.user.username
    sessionStorage.password = state.user.password
    sessionStorage.is_logged_in = state.user.is_logged_in

  'RESET_USER': (state) ->
    state.user =
      first_name: null
      last_name: null
      username: null
      password: null
      is_logged_in: false

    state.client_list = []

    sessionStorage.first_name = null
    sessionStorage.last_name = null
    sessionStorage.username = null
    sessionStorage.password = null
    sessionStorage.is_logged_in = false



// WEBPACK FOOTER //
// ./src/vuex/mutations.coffee